import { render, staticRenderFns } from "./compression-suggestion.vue?vue&type=template&id=36c015ac&scoped=true"
import script from "./compression-suggestion.vue?vue&type=script&lang=js"
export * from "./compression-suggestion.vue?vue&type=script&lang=js"
import style0 from "./compression-suggestion.vue?vue&type=style&index=0&id=36c015ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c015ac",
  null
  
)

export default component.exports